import React from 'react';
import * as cl from '../MainInfo/MainInfo.module.scss';
/*import PlaySVG from '../SVG/PlaySVG';
import CircleProgressBar from '../CircleProgressBar/CircleProgressBar';
import CheckSVG from '../SVG/CheckSVG';
import { LockIcon } from '../../../icons/Lock';*/

const NextPreview = ({ nextBlock, onNextClick }) => {
  const nextButton = (
    <span className={cl.nextButton} onClick={() => onNextClick(nextBlock.title)}>
      Next: {nextBlock.title}
    </span>
  );

  return nextButton;

  /*const getItem = (item) => {
    return (
      <a href="/#">
        <i>
          {item.has_access
            ? <PlaySVG/>
            : <LockIcon color="#8898AE"/>
          }
        </i>
        <span>{item.title}</span>
        {item.progress
          ? <i className={cl.done}><CheckSVG/></i>
          : <CircleProgressBar/>
        }
      </a>
    );
  };

  const lesson = Object.values(nextBlock.lessons)?.[0];

  if (lesson) {
    return (
      <div className={cl.wrapperPreview} onClick={() => onNextClick(nextBlock.title)}>
        <div className={cl.lessons}>
          <h2 className={cl.lessons__title}>
            <a href={lesson.permalink}>
              <span>1.</span>
              {lesson.title}
            </a>
          </h2>

          <ul className={cl.lessons_list}>
            {
              lesson.topics &&
              lesson.topics.length === 0 && (
                <li className={cl.lessons__lesson}>
                  {getItem(lesson)}
                </li>
              )
            }
            {
              lesson.topics &&
              lesson.topics.length > 0 &&
              lesson.topics.slice(0, 2).map((topic, index) => {
                return (
                  <li className={cl.lessons__lesson} key={index}>
                    {getItem(topic)}
                  </li>
                )
              })
            }
          </ul>
        </div>
        {nextButton}
      </div>
    );
  }

  const isHaveTopics = nextBlock.topics?.length > 0

  return (
    <div className={cl.wrapperPreview} onClick={() => onNextClick(nextBlock.title)}>
      <div className={cl.lessons}>
        <h2 className={cl.lessons__title}>
          <a href={nextBlock.permalink}>
            <span>1.</span>
            {nextBlock.title}
          </a>
        </h2>

        <ul className={cl.lessons_list}>
          {/!* if we haven't topics then duplicate parent *!/}
          {isHaveTopics
            ? (
              nextBlock.topics.slice(0, 2).map((topic, index) => (
                  <li className={cl.lessons__lesson} key={index}>
                    {getItem(topic)}
                  </li>
                )
              )
            ) : (
              <li className={cl.lessons__lesson}>
                {getItem(nextBlock)}
              </li>
            )
          }
        </ul>
      </div>
      {nextButton}
    </div>
  )*/
};

export default NextPreview;
